import { Navigate, useLocation } from "react-router-dom";
import { userRolEnum } from "../types/enumTypes";
import { rolType } from "../types/userTypes";
import NavBar from "./NavBar";
import { useEffect, useState } from "react";
import { continueSession, validateSession } from "../services/Validation";
import FullScreenLoader from "./FullScreenLoader";

const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

export const ProtectedRoute = ({ children, roles }: { children: any, roles: Array<string> }) => {
  const [loading, setLoading] = useState(true);
  const [step, setStep] = useState("Iniciando...");
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const jwtToken = params.get("jwt");
  const refreshToken = params.get("rf");
  const IdApp = params.get("IdApp");

  useEffect(() => {

    const run = async () => {
      try {
        const hasUrlToken = !!jwtToken;

        if (hasUrlToken) {
          setStep("Validando...");
          await delay(100);

          await localStorage.removeItem("Roles");
          await localStorage.removeItem("jwtToken");
          await localStorage.removeItem("refreshToken");

          await localStorage.setItem("jwtToken", jwtToken!);
          await localStorage.setItem("refreshToken", refreshToken || "");
          await localStorage.setItem("IdApp", IdApp || "");

          const ok = await continueSession(jwtToken!);

          if (!ok) {
            setStep("Error al validar sesión");
            await delay(1000);
            setIsAuthenticated(false);
            setLoading(false);
            return;
          }

          const storedRoles = JSON.parse(localStorage.getItem("Roles") || "[]");
          if (storedRoles.length > 0) {
            setStep("Bienvenido...");
            await delay(1000);
            setIsAuthenticated(true);
          } else {
            setStep("Sin roles válidos");
            await delay(1000);
            setIsAuthenticated(false);
          }

          setLoading(false);
          return;
        }

        let storedRoles = JSON.parse(localStorage.getItem("Roles") || "[]");
        if (storedRoles.length > 0) {
          setStep("...");
          await delay(500);

          validateSession();
          setIsAuthenticated(true);
          setLoading(false);
          return;
        }

        setStep("Token no proporcionado");
        await delay(1000);
        setIsAuthenticated(false);
        setLoading(false);
      } catch (err) {
        console.error("Error general en ProtectedRoute:", err);
        setStep("Error inesperado");
        await delay(1000);
        setIsAuthenticated(false);
        setLoading(false);
      }
    };

    run();
  }, [location]);

  if (loading) {
    return <FullScreenLoader loading={loading} text={step} />;
  }

  if (process.env.REACT_APP_HAS_BACK !== "SI") {
    return <p>404 - No encontrado {process.env.REACT_APP_HAS_BACK}</p>
  }

  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }

  const userRoles = JSON.parse(localStorage.getItem("Roles") || "[]");
  const hasRole = userRoles.some((r: rolType) => roles.includes(r.ControlInterno) || r.ControlInterno === userRolEnum.admin);

  return hasRole ? <NavBar>{children}</NavBar> : <Navigate to="/" />;
};

